export default {
      id: "eld_driver-usage",
      viewBox: "0 0 17 21",
      url: __webpack_public_path__ + "img/icons.svg#eld_driver",
      toString: function () {
        return this.url;
      }
    }